export default "__VITE_ASSET__COGk9agb__"